export const BATTERIES_PAGE_SIZE = 25;
